/*
 * moleculer
 * Copyright (c) 2018 MoleculerJS (https://github.com/moleculerjs/moleculer)
 * MIT Licensed
 */

"use strict";

module.exports = {

	// Circuit-breaker states
	CIRCUIT_CLOSE: 				"close",
	CIRCUIT_HALF_OPEN: 			"half_open",
	CIRCUIT_HALF_OPEN_WAIT: 	"half_open_wait",
	CIRCUIT_OPEN: 				"open"

};
